import { cardsItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">精品推荐</h2>
        <p className="section-subtitle">编辑精选热门漫画作品，韩漫日漫国漫一网打尽</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cardsItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200 comic-card-hover cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}